module.exports = __webpack_public_path__ + "img/pro03.61890ca7.jpg";